/* 
 * @author Mateusz Mieszczak <mateusz.mieszczak at bossbyte.com>
 * @copyright BossByte Web Application
 */


app.controller('MessageDrafts', function ($scope, mailboxService, $rootScope, $http, _$privileges) {
    $scope.showLoader=false;
    $scope.rows = [];
    $rootScope.checkboxList.clear();

    $scope.data = {
        "can_write": _$privileges.write("message")
    };

    /*
     * pagination
     */

    $scope.pagination = {
        currentPage: 1,
        totalItems: 1,
        itemsPerPage: 1
    };

    $scope.setPage = function () {
        $scope.list($scope.pagination.currentPage);
    };

    $scope.list = function (page) {
        $scope.showLoader=true;
        var filter = {
            "notification_category_id": $scope.search.filter.notification_category_id.value!=null ? $scope.search.filter.notification_category_id.value.join() : "",
            "notification_id": $scope.search.filter.notification_id.value!=null ? $scope.search.filter.notification_id.value.join() : "",
            "ready_to_send": $scope.search.filter.ready_to_send.value,
            "created_user": $scope.search.filter.user.value
        };

        var promise = mailboxService.draft(page, filter);
        promise.then(
                function (payload) {
                    $scope.showLoader=false;
                    $scope.rows = payload.data.data;
                    $scope.pagination = {
                        totalItems: payload.data.total,
                        currentPage: payload.data.current_page,
                        itemsPerPage: payload.data.per_page
                    };
                });
    };

    $scope.search = {
        "data": {},
        "get": function () {
            $scope.showLoader=true;
            var promise = mailboxService.filter();
            promise.then(
                    function (payload) {
                        $scope.showLoader=false;
                        $scope.search.data = payload.data;
                    },
                    function (errorPayload) {
                        $rootScope.notification.show('error', 'Błąd ładowania filtrów wyszukiwania skrzynki wiadomości');
                    });
        },
        "filter": {
            "notification_category_id": {
                value: []
            },
            "mailbox_state_id": {
                value: []
            },
            "notification_id": {
                value: []
            },
            "user": {
                value: "",
            },
            "ready_to_send": {
                value: "",
                options: [
                    {label: "Dowolny", value: ""},
                    {label: "Projekt", value: 0},
                    {label: "Gotowa do wysyłki", value: 1}
                ]
            }
        }
    };

    $scope.list(1);
    $scope.search.get();

    $scope.panel = {
        "show": function(){
            
        },
        "concate": function(){
            var ids = [];
            for(var i=0; i<$scope.rows.length;i++){
                if($scope.rows[i].checked)
                    ids.push($scope.rows[i].id);
            }
            return ids;
        },
        "delete": function () {
            var promise = mailboxService.delete($scope.panel.concate());
            promise.then(
                    function (payload) {
                        if (payload.data.code == 1) {
                            $rootScope.notification.show('success', payload.data.msg);
                            $scope.list(1);
                            $rootScope.checkboxList.clear();
                        } else {
                            $rootScope.notification.show('error', payload.data.msg);
                        }
                    });
        }
    };

    $scope.onFilter = function () {

    };

    $scope.queryAssign = function (search) {
        return $http.get("/user?search=" + search).then(function (results) {
            return results.data;
        });
    };

    $scope.clearFilters = function () {
        $scope.search.filter.notification_category_id.value = [];
        $scope.search.filter.mailbox_state_id.value = [];
        $scope.search.filter.notification_id.value = []
        $scope.search.filter.user.value = "";
        $scope.search.filter.ready_to_send.value = "";
        $scope.list(1);
    };

});
                  